import { useSelector } from 'react-redux'
import { Navigate, Outlet } from 'react-router-dom'

// slices
import { loginState } from '../login/login.slice'

// constants
import { DOMAIN_LIST, SUPER_ADMIN } from '../../constants/roles'

// routes
import { PRIVATE_ROUTES } from '../../routes'
import { workspaceState } from '../workSpace/workSpace.slice'

// PUBLIC ROUTES
const PublicRoute = () => {
    const { userProfile, status } = useSelector(loginState)
    const { isByPass } = useSelector(workspaceState)
    if (
        status !== 'loading' &&
        userProfile !== undefined &&
        userProfile?.role?.roleName !== undefined &&
        userProfile?.phone
    ) {
        if (
            userProfile?.role?.roleName === SUPER_ADMIN &&
            DOMAIN_LIST.includes(userProfile?.currentWorkSpace?.domain)
        ) {
            // return <Navigate to={`${PRIVATE_ROUTES.workSpace}`} />
            return <Navigate to={`${PRIVATE_ROUTES.home}`} />
        } else if (
            userProfile?.activeProject === null &&
            DOMAIN_LIST.includes(userProfile?.currentWorkSpace?.domain)
        ) {
            // return <Navigate to={`${PRIVATE_ROUTES.userWorkSpace}`} />

            if (userProfile?.isCandidateUser) {
                return <Navigate to={`${PRIVATE_ROUTES.profile}`} />
            } else {
                return <Navigate to={`${PRIVATE_ROUTES.home}`} />
            }
        } else if (
            userProfile?.activeProject === null &&
            !DOMAIN_LIST.includes(userProfile?.currentWorkSpace?.domain)
        ) {
            return <Navigate to={`${PRIVATE_ROUTES.projects.root}`} />
        } else {
            if (isByPass) {
                return <Navigate to={`${PRIVATE_ROUTES.home}`} />
            } else {
                return <Navigate to={`${PRIVATE_ROUTES.overview}`} />
            }
        }
    } else {
        return <Outlet />
    }
}

export default PublicRoute
